<template>
    <div class="chat_retry--wrapper">
        <span class="chat_retry--button" @click="retryConnect()">{{ $t('retry') }}</span>
        <div class="chat_retry--text">{{ $t('cannotConnect') }}</div>
    </div>
</template>

<script>
import { RETRY } from '../constants/mutation-types'
import { mapMutations } from 'vuex'

export default {
  name: 'RetryButton',
  methods: {
    retryConnect: function () {
      this.$store.commit(RETRY)
    }
  }
}
</script>

<style lang="scss">
.chat_retry--wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 100%;
    height: 40px;
    text-align: center;
    .chat_retry--button {
        width: 60px;
        height: 40px;
        cursor: pointer;
        background-color: lightgray;
        padding: 4px 8px;
        border-radius: 4px;
    }
    .chat_retry--text {
        font-size: 13px;
        padding-top: 4px;
    }
}
</style>
